var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-icon-export"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    width: 22,
    height: 20,
    transform: "translate(0.051 0.213)",
    fill: "#0d37c9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22634",
    "data-name": "Group 22634",
    transform: "translate(-0.051 -0.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22633",
    "data-name": "Group 22633",
    clipPath: "url(#clip-path-icon-export)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    d: "M22.05,17.457V13.782a.919.919,0,1,0-1.838,0v3.675a.919.919,0,0,1-.919.919H2.756a.919.919,0,0,1-.919-.919V13.782a.919.919,0,1,0-1.838,0v3.675a2.756,2.756,0,0,0,2.756,2.756H19.294a2.756,2.756,0,0,0,2.756-2.756m-5.862-4.8-4.594,3.675a.919.919,0,0,1-1.139,0L5.862,12.661A.919.919,0,0,1,7,11.227l3.105,2.481V.919a.919.919,0,0,1,1.838,0V13.708l3.105-2.481a.919.919,0,1,1,1.139,1.433Z",
    fill: "#0d37c9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExport);
export default __webpack_public_path__ + "static/media/icon-export.7396eb0b67c61b75eb49ab28103dcc7d.svg";
export { ForwardRef as ReactComponent };